import axios from 'axios';

export const updateOrder = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'patch',
    url: Routes.update_order_abstract_custom_fields_path({ ... {...requestParams}, format: 'json' }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  });

  promise.then(response => {
    callback(response);
  }).catch(error => {
    callback(error.response);
  });
}
